import { createElement } from 'react';
import { useRouter } from '../hooks/useRouter';
import { Redirect } from 'react-router';
export function withProtection(Component, options) {
    return (props) => {
        const router = useRouter();
        return options.access(props)
            ? createElement(Component, props)
            : createElement(Redirect, { to: `${router.basePath}${options.redirectTo}` });
    };
}
